import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IPopcornRepository } from '../../repositories/interfaces/iPopcornRepository';
import { IGetRewindParams } from '../../../entity/interface/iPopcorn';

export interface IGetByPopcornUrlUseCase {
    execute(url: string): Promise<any>;
}

export class GetByPopcornUrlUseCase implements IGetByPopcornUrlUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get popcornRepo(): IPopcornRepository {
        return container.resolve<IPopcornRepository>(DI.REPOSITORIES.IPopcornRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(url: string): Promise<any> {
        return await this.popcornRepo.getByPopcornUrl(url);
    }
}
